import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/componentsDS/Button/Button';
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';
import Icon from '@/componentsDS/Icon/Icon';

const InputField = ({
    id,
    name,
    inputValue,
    type,
    placeholder,
    disabled,
    onChange,
    onKeyDown,
    onClick,
    register,
    ref,
    hasChips,
    chipInputMultiple,
    disableClear,
    onClear,
    inputProps,
}) => {
    return (
        <div className="DS__chip-input-field">
            <input
                id={id}
                name={name}
                {...(!register && { value: inputValue })}
                type={type}
                placeholder={placeholder}
                readOnly={disabled}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick?.(e);
                }}
                className="DS__input-field__input"
                data-testid="input-field__input"
                ref={register ?? ref}
                autoComplete="off"
                {...inputProps}
            />
            {inputValue && !disabled && !disableClear && ((hasChips && chipInputMultiple) || !hasChips) && (
                <div className="DS__input-field__clear-btn">
                    <Button
                        type={ButtonType.UTILITY}
                        variant={ButtonVariant.UTILITY}
                        onClick={onClear}
                        text={<Icon name="x-mark" style={{ type: "outlined" }} size="small" />}
                    />
                </div>
            )}
        </div>
    );
};

InputField.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    inputValue: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    onClick: PropTypes.func,
    register: PropTypes.func,
    ref: PropTypes.any,
    hasChips: PropTypes.bool,
    chipInputMultiple: PropTypes.bool,
    disableClear: PropTypes.bool,
    onClear: PropTypes.func,
    inputProps: PropTypes.object,
};

export default InputField;
